// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}
:host .cancel-confirm-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-lg);
  height: 100%;
  padding: var(--space-lg);
  box-sizing: border-box;
  background-color: var(--color-surface);
  border: 1.5px solid var(--color-red-50);
  border-radius: var(--radius-xl);
}
:host .cancel-confirm-card.theme-primary {
  border-color: var(--color-action-secondary-bg);
}
:host .icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  background-color: var(--color-red-50);
  border-radius: var(--radius-xl);
}
:host .theme-primary .icon-container {
  background-color: var(--color-action-primary-bg);
}
:host .text-container {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  width: 100%;
  text-align: center;
}
:host .text-container .title {
  margin: 0;
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  line-height: var(--font-line-height-md);
  color: var(--color-text-primary);
}
:host .text-container .subtitle {
  margin: 0;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--font-line-height-sm);
  color: var(--color-text-secondary);
}
:host .buttons-container {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  width: 100%;
}
:host .buttons-container flw-button {
  display: block;
  width: 100%;
}
:host .buttons-container .back-button {
  width: 100%;
  height: 52px;
  box-sizing: border-box;
  background-color: var(--color-surface);
  border: 1.5px solid var(--color-text-secondary);
  border-radius: var(--radius-lg);
  color: var(--color-text-secondary);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  cursor: pointer;
}
:host .cancel-confirm-card:not(.theme-primary) .buttons-container flw-button::part(native) {
  background-color: var(--color-surface);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/confirm-delete-modal/confirm-delete-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,YAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;EACA,wBAAA;EACA,sBAAA;EAEA,sCAAA;EACA,uCAAA;EACA,+BAAA;AAAR;AAEQ;EACI,8CAAA;AAAZ;AAII;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EAEA,qCAAA;EACA,+BAAA;AAHR;AAMI;EACI,gDAAA;AAJR;AAOI;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AALR;AAOQ;EACI,SAAA;EACA,sCAAA;EACA,8BAAA;EACA,uCAAA;EACA,gCAAA;AALZ;AAQQ;EACI,SAAA;EACA,uCAAA;EACA,8BAAA;EACA,uCAAA;EACA,kCAAA;AANZ;AAUI;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;AARR;AAUQ;EACI,cAAA;EACA,WAAA;AARZ;AAWQ;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,sCAAA;EACA,+CAAA;EACA,+BAAA;EACA,kCAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,eAAA;AAVZ;AAcI;EACI,sCAAA;AAZR","sourcesContent":[":host {\r\n    display: block;\r\n    height: 100%;\r\n\r\n    .cancel-confirm-card {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: var(--space-lg);\r\n        height: 100%;\r\n        padding: var(--space-lg);\r\n        box-sizing: border-box;\r\n\r\n        background-color: var(--color-surface);\r\n        border: 1.5px solid var(--color-red-50);\r\n        border-radius: var(--radius-xl);\r\n\r\n        &.theme-primary {\r\n            border-color: var(--color-action-secondary-bg);\r\n        }\r\n    }\r\n\r\n    .icon-container {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        flex-shrink: 0;\r\n        width: 60px;\r\n        height: 60px;\r\n\r\n        background-color: var(--color-red-50);\r\n        border-radius: var(--radius-xl);\r\n    }\r\n\r\n    .theme-primary .icon-container {\r\n        background-color: var(--color-action-primary-bg);\r\n    }\r\n\r\n    .text-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: var(--space-md);\r\n        width: 100%;\r\n        text-align: center;\r\n\r\n        .title {\r\n            margin: 0;\r\n            font-weight: var(--font-weight-medium);\r\n            font-size: var(--font-size-md);\r\n            line-height: var(--font-line-height-md);\r\n            color: var(--color-text-primary);\r\n        }\r\n\r\n        .subtitle {\r\n            margin: 0;\r\n            font-weight: var(--font-weight-regular);\r\n            font-size: var(--font-size-sm);\r\n            line-height: var(--font-line-height-sm);\r\n            color: var(--color-text-secondary);\r\n        }\r\n    }\r\n\r\n    .buttons-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: var(--space-md);\r\n        width: 100%;\r\n\r\n        flw-button {\r\n            display: block;\r\n            width: 100%;\r\n        }\r\n\r\n        .back-button {\r\n            width: 100%;\r\n            height: 52px;\r\n            box-sizing: border-box;\r\n\r\n            background-color: var(--color-surface);\r\n            border: 1.5px solid var(--color-text-secondary);\r\n            border-radius: var(--radius-lg);\r\n            color: var(--color-text-secondary);\r\n            font-family: var(--font-family-base);\r\n            font-weight: var(--font-weight-medium);\r\n            font-size: var(--font-size-md);\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .cancel-confirm-card:not(.theme-primary) .buttons-container flw-button::part(native) {\r\n        background-color: var(--color-surface);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
